import { render, staticRenderFns } from "./NormalSearchNav453.vue?vue&type=template&id=3ffc4452&scoped=true&"
import script from "./NormalSearchNav453.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav453.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffc4452",
  null
  
)

export default component.exports